import type { GetPromoCodeResponse } from '../../routes/api/stripe/promo/[code]/+server';
import { deserialize } from '$app/forms';

const TIMED_COUPON_KEY = 'timed_coupon';
const MINUTES_TO_SECONDS = 60;

export const getCurrentTimestamp = () => Math.floor(Date.now() / 1000);

export const isExpired = (time: number) => getCurrentTimestamp() >= time;

export const getStoredTimer = () => {
  const storedEndTime = localStorage.getItem(TIMED_COUPON_KEY);
  return storedEndTime ? parseInt(storedEndTime, 10) : undefined;
};

export const canStartNewTimer = () => {
  const storedEndTime = getStoredTimer();
  return !storedEndTime || isExpired(storedEndTime);
};

export const initializeTimer = (duration: number): number | undefined => {
  const storedEndTime = getStoredTimer();

  if (storedEndTime && !isExpired(storedEndTime)) {
    return storedEndTime;
  }

  if (canStartNewTimer()) {
    const newEndTime = getCurrentTimestamp() + duration * MINUTES_TO_SECONDS;
    localStorage.setItem(TIMED_COUPON_KEY, newEndTime.toString());
    return newEndTime;
  }

  return undefined;
};

export const handleCouponAndPromoCode = async (): Promise<GetPromoCodeResponse | undefined> => {
  const response = await fetch('?/timedPromoCode', {
    method: 'POST',
    body: new FormData(),
    headers: {
      'x-sveltekit-action': 'true',
    },
  });

  const result = deserialize(await response.text());

  if (result.type !== 'success') {
    return undefined;
  }

  return result.data as GetPromoCodeResponse;
};
